export const SET_FRAMEWORK_ID = "SET_FRAMEWORK_ID";
export const SET_CATEGORY_ID = "SET_CATEGORY_ID";
export const RESET_TOPIC = "RESET_TOPIC";
